import * as React from "react";
import { connect } from "react-redux";
import { FlexWrapperFocus } from "../../../../components/core/03-base/FlexWrapper";
import { Navbar } from "@vwpfs/mary-air-lib/components/air/07-organisms";
import { NavbarStack, NavbarStackContent,
    NavbarStackLeft, NavbarStackRight } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Stack";
import { NavbarTitle } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Title";
import { NavbarIcon } from "@vwpfs/mary-air-lib/components/air/07-organisms/Navbar/Icon";
import { DispatchFunc } from "../../../../store/ActionTypes";
import { ThemePalette, ThemeShadowSizes } from "@vwpfs/mary-air-lib/theme/_Types";
import { flexSetFocus } from "../../../../utils/redux/ActionTypes";
import * as I18n from "../../../../utils/translations/I18n";
import { Button } from "@vwpfs/mary-air-lib/components/air/05-atoms/Button";
import { LogoutBtn } from "../../05-atoms/keycloaklogoutbtn";

interface DispatchProps {
    setFocus: () => void;
}

const mapDispatchToProps = (dispatch: DispatchFunc): DispatchProps => ({
    setFocus: () => dispatch(flexSetFocus(FlexWrapperFocus.SIDEBAR)),
});

type Props = DispatchProps;

class HomeNavBarComp extends React.Component<Props, {}> {

    public constructor(props: Props) {
        super(props);
        this.setFocus = this.setFocus.bind(this);
    }

    public render() {
        return (
            <Navbar
                theme={{
                    palette: ThemePalette.CONTRAST_PRIMARY,
                    shadow: ThemeShadowSizes.SMALL,
                }}
                className={"scl-o-navbar__toggle-sidebar"}
            >
                <NavbarStack>
                    <NavbarStackLeft>
                        {
                            <NavbarIcon
                            >
                                <Button
                                    icon={"bars"}
                                    className="scl-o-navbar__icon"
                                    link={{ onClick: this.setFocus() }}
                                />
                            </NavbarIcon>
                        }
                    </NavbarStackLeft>
                    <NavbarStackContent>
                        <NavbarTitle>{I18n.getText("app.app-title", "Extended Warranty System")}</NavbarTitle>
                    </NavbarStackContent>
                    <NavbarStackRight>
                       <NavbarIcon>
                            <LogoutBtn />
                        </NavbarIcon>
                    </NavbarStackRight>
                </NavbarStack>
            </Navbar>
        );
    }
    private setFocus() {
        return () => this.props.setFocus();
    }
}

// eslint-disable-next-line max-len
// export const HomeNavBarWrapper: React.FunctionComponent<OwnProps> = props => (<HomeNavBarComp {...props as Props} />);

/**
 *
 */
export const HomeNavBar = connect(
    undefined,
    mapDispatchToProps,
)(HomeNavBarComp);

export const testUtil = {
    mapDispatchToProps: mapDispatchToProps,
};
